import Vue from 'vue'
import App from './App.vue'
import http from '@/utils/http'
import router from './router'
import store from './store'
import '@/assets/css/reset.scss'
import '@/assets/css/border.css'
import fastCLick from 'fastclick'
import VConsole from 'vconsole'
fastCLick.attach(document.body);
import {
  Tabbar,
  TabbarItem,
  NavBar,
  Tab,
  Tabs,
  Toast,
  Button,
  Cell,
  CellGroup,
  PullRefresh,
  Row,
  Col,
  ActionSheet,
  Icon,
  Image,
  Lazyload,
  ImagePreview,
  Swipe,
  SwipeItem,
  Loading
} from "vant";
import 'vant/lib/index.css'
import {getPlatformInstance} from '@/platforms'
/*  rem  */
import 'amfe-flexible'
import 'amfe-flexible/index.js'
/*
 * iconfont
 * 使用方法
 * <van-icon class="iconfont" class-prefix="icon" name="activity_fill"/>
 * */

import '@/assets/css/iconfont.css'
/*  theme  */
import "@/assets/css/common.css"
Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Tab).use(Tabs)
    .use(Button).use(Cell).use(CellGroup).use(PullRefresh).use(Row).use(Col).use(ActionSheet).use(Icon).use(Image).use(Toast).use(Lazyload).use(ImagePreview).use(Swipe).use(SwipeItem).use(Loading);
Vue.config.productionTip = false;
Vue.prototype.$http = http;

/*
 *动态改变页面title
 * v-title data-title="测试title"
 * */
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
// 全局混入
Vue.mixin({
  components: {
    Error: () => import('@/components/Error')
  },
  data() {
    return {
      MIXIN_PAGE_STATUS_CLASS: {
        LOADING: 'ht-loading',       // 正在加载
        EMPTY: 'ht-empty',           // 无数据
        NET_ERROR: 'ht-net-error'    // 网络请求失败
      },
      mixinPageStatusClass: null,
    }
  },
  created() {
    this.mixinPageLoading()
  },
  methods: {
    mixinPageEmpty() {
      this.$router.push("/empty/empty")
    },
    mixinPageNetError(error) {
      this.$router.push("/empty/error/"+error)
    },
    mixinPageLoading() {
      //this.mixinPageStatusClass = this.MIXIN_PAGE_STATUS_CLASS.LOADING
    },
    mixinShowLoading() {
      // 显示正在加载
      Toast.loading({message: '加载中...', forbidClick: true,})
    },
    mixinClearLoading() {
      // 隐藏正在加载
      setTimeout(() => Toast.clear(), 100)
    },
  },
})
// 全局指令
Vue.directive('image-preview', {
  inserted: function (el) {
    el.addEventListener('click', event => {
      if (/^img$/i.test(event.target.nodeName)) {
        const imgArr = Array.prototype.map.call(el.getElementsByTagName('img'), item => item.src)
        const index = Array.prototype.indexOf.call(imgArr, event.target.src)
        ImagePreview({
          images: imgArr,
          startPosition: index,
          closeOnPopstate: true,
        })
      }
    })
  }
})
//根据缓存判断是否开启debug
if(localStorage.getItem("debug") === '1'){
  window.vconsole = new VConsole();
}
// 平台相关初始化操作
/*getPlatformInstance()
    .then(platform => {
      console.log(platform)
      platform.init().then((res)=>{
        new Vue({
          http,
          router,
          store,
          render: h => h(App)
        }).$mount('#app')
      }).catch(err=>{console.log(err)})
    })
    .catch(err => {
      console.log(err)
})*/
// 平台相关初始化操作
getPlatformInstance()
  .then(platform => {
    console.log(platform)
    platform.init()
  })
  .catch(err => {
    console.log(err)
  }).finally(() => {
  new Vue({
    http,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})


